import React from "react";
import { Card, CardContent, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const PickupOrderCard = ({ pickupOrder, navigate, hideNavButton }) => {
  const { t } = useTranslation();
  return (
    <Card>
      <CardContent spacing={2}>
        <Typography variant="h6" mb={1}>
          {t("Order Id")}: {pickupOrder.id}
        </Typography>
        <Typography variant="body2">
          {t("Plant name")}: {pickupOrder.plant_name}
        </Typography>
        <Typography variant="body2">
          {t("Pickup date")}: {pickupOrder.pickup_date}
        </Typography>
        <Typography variant="body2">
          {t("Total Quantity (kg)")}: {pickupOrder.total_quantity_kg}
        </Typography>
        <Typography variant="body2">
          {t("Total Estimated Payout")}: {t("Rs")}.{" "}
          {pickupOrder.total_estimated_payout}
        </Typography>
        <Typography variant="body2">
          {t("Total Paid Amount")}: {t("Rs")}. {pickupOrder.total_paid_amount}
        </Typography>
        <Typography variant="body2">
          {t("Status")}: {pickupOrder.status}
        </Typography>
        {!hideNavButton && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate(`/pickup-order/${pickupOrder.id}`)}
            sx={{ mt: 2 }}
            fullWidth
          >
            {t("Manage")}
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

export default PickupOrderCard;
